import { ComponentSingleStyleConfig, useStyleConfig } from "@chakra-ui/react";
import React from "react";
import {
  ComponentStyleProps,
  componentStylePropsOf,
} from "../../../../lib/styles/props/component-style-props";
import { ConfirmationModalBase } from "../ConfirmationModalBase/ConfirmationModalBase";

export type DeleteConfirmationModalProps = {
  isOpen: boolean;
  onClose: () => void;

  title: string;
  message?: string;
  deleteButtonLabel: string;
  cancelButtonLabel: string;

  /**
   * 削除を確定したときのコールバック。
   */
  onConfirm: () => void;
  /**
   * キャンセルしたときのコールバック。
   */
  onCancel?: () => void;
} & ComponentStyleProps;

export const DeleteConfirmationModal = ({
  isOpen,
  onClose,

  title,
  message,
  deleteButtonLabel,
  cancelButtonLabel,

  onConfirm,
  onCancel,

  sx,
  ...rest
}: DeleteConfirmationModalProps) => {
  const styles = useStyleConfig("DeleteConfirmationModalStyles");

  return (
    <ConfirmationModalBase
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      message={message}
      confirmButtonLabel={deleteButtonLabel}
      confirmButtonLabelColorScheme="red"
      cancelButtonLabel={cancelButtonLabel}
      onConfirm={onConfirm}
      onCancel={onCancel}
      sx={{ ...styles, ...sx }}
      {...rest}
    />
  );
};

export const DeleteConfirmationModalStyles: ComponentSingleStyleConfig = {
  baseStyle: {},
};
